import AxiosConfig from '../../../config/AxiosConfig';

const deleteQuote = async (quoteReference) => {
  try {
    const response = await AxiosConfig.create(
      'delete',
      `/quote/${quoteReference}`
    )
      .call()
      .getResponseData();

    return response;
  } catch (err) {
    console.error('Failed to delete quote:', err);
    const errorMessage = `Suppression du devis échouée: ${err?.message}`;
    throw new Error(errorMessage);
  }
};

export default deleteQuote;
